import {RestService} from "@/services/rest/RestService";
import {SalvusHealthAuthentication} from "@/models/nvpair/SalvusHealthAuthentication";

export type SalvusHealthPharmacyAppointmentConfiguration = {
    id: string,
    title: string,
    appointmentCategory: string,
    appointmentDuration: string,
    appointmentLink: string,
    slotInterval: number,
    targetUserGroup: string,
    color: string,
    active: boolean,
    registrationIdRequired: boolean,
    position: number,
    careflow_type: string
};

export class SalvusHealthRestService extends RestService
{
    private baseUrlSandbox: string = 'https://api.sandbox.salvus-health.com';
    private baseUrl: string = 'https://api.salvus-health.com';
    private isDevelopment: boolean = false;

    public async getPharmacyAppointmentConfiguration(apbNumber: string, authentication: SalvusHealthAuthentication): Promise<SalvusHealthPharmacyAppointmentConfiguration[]> {
        let baseUrl = this.baseUrl;
        if (this.isDevelopment) {
            // If we want to test a new version in development
            baseUrl = this.baseUrlSandbox;
        }

        const axiosInstance = this.getAxiosInstance();
        axiosInstance.defaults.headers.common['Content-Type'] = 'application/json';

        const response = await axiosInstance.get(
            baseUrl + "/public/AppointmentTypes/" + authentication.apb_number,
            {
                headers: {
                    Authorization: "Bearer " + authentication.api_key,
                },
            }
        );

        return response.data as SalvusHealthPharmacyAppointmentConfiguration[];
    }
}
